import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap prerenders real HTML into #root at build time. When that
// prerendered content exists, hydrate it (attach React to the existing
// DOM) instead of wiping and re-rendering. In dev, or if prerendering
// ever fails, the element is empty and we fall back to a normal render.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}